/**
 * 启动引导：原生壳必须先完成 initNativeApp()（固定国际服、清理旧测试会话、拿 build 号、铺满安全区），
 * 之后才能导入 app.js——i18n 与 api 在模块导入时就会读服务器选择。浏览器里 initNativeApp 是空操作。
 */
import { initNativeApp } from './services/nativeApp'
import { checkBrowserSupport } from './services/browserSupport'

import '@fontsource/fusion-pixel-12px-proportional-sc/400.css'
import '@fontsource-variable/noto-sans-sc/wght.css'
import './styles/pixel/tokens.css'
import './styles/pixel/markdown.css'

if (checkBrowserSupport()) {
  initNativeApp()
    .then(() => import('./app'))
    .then(({ startApp }) => startApp())
}
